import { useEffect, useRef } from "react";
// import Board from "../../chessBoard3/components/Board";
import Board from "../../chessBoard/components/Board";
import { Chess } from "@chesshotel/chess";
// import { Chess } from "./chess";
import { convertMoves } from "../../util/moves";
import { useState } from "react";
import { ChessSets } from "@chesshotel/constants";
import { cn } from "@/lib/utils";
import { move2uci, uci2move } from "@chesshotel/gameReview";
import { MoveShort, UciMove } from "@chesshotel/chess";
import { Button } from "../ui/button";
import { useSettings } from "@/redux/settings";
import MoveIcon from "@/components/common/move-icon";
import { MoveType } from "@chesshotel/types";
import pieceStyles from "../../chessBoard/components/Piece.module.css";
import Piece from "@/chessBoard/components/Piece";
import { FaStepBackward, FaStepForward } from "react-icons/fa";
import { Progress } from "../ui/progress";
import useTranslation from "next-translate/useTranslation";

// import Puzzle from "@/pages/puzzle";

// const chess = Chess();

function King() {
  return <img width={35} height={35} src="/images/pieces/staunty/wK.svg" />;
}

enum LessonState {
  OPENING,
  // START,
  IN_PROGRESS,
  CORRECT_MOVE,
  INCORRECT_MOVE,
  DONE,
}
// const startFen = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";

export default function LessonBoard(props) {
  const { t } = useTranslation("common");
  const { openingFen, openingLastMove, playingWhite, lines, introText, title } =
    props;

  const boardSize = 504;
  const settings = useSettings();
  settings.chessSet = ChessSets.STAUNTY;

  // const [positionIndex, setPositionIndex] = useState(0);

  const [moveIndex, setMoveIndex] = useState(0);
  const [lineIndex, setLineIndex] = useState(0);
  const [maxMoveIndex, setMaxMoveIndex] = useState(0);
  const [count, setCount] = useState(0);

  const [moves, setMoves] = useState<any[]>([]);
  const [possibleMovesArr, setPossibleMovesArr] = useState([]);
  const [fen, setFen] = useState(openingFen);
  const [lastMove, setLastMove] = useState(uci2move(openingLastMove));
  // const positionIndex = useRef(0);
  const [lessonState, setLessonState] = useState(LessonState.OPENING);
  const [highLightKey, setHighLightKey] = useState(null);

  const chess = useRef(new Chess()).current;

  const line = lines[lineIndex];
  const maxLines = lines.length;

  const commentIndex = playingWhite
    ? Math.ceil(moveIndex / 2)
    : Math.floor(moveIndex / 2);

  let comment = line.comments?.[commentIndex];

  const isWhiteTurn = moveIndex % 2 === 0;
  const opponentTurn =
    (playingWhite && !isWhiteTurn) || (!playingWhite && isWhiteTurn);

  if (opponentTurn) {
    comment = isWhiteTurn ? "White moves." : "Black moves.";
  }
  if (lessonState === LessonState.OPENING) {
    comment = introText;
  }

  const possibleMoves = possibleMovesArr[moveIndex];

  // console.log("moveIndex", moveIndex);
  // console.log("possibleMovesArr", possibleMovesArr);
  // console.log("possibleMoves", possibleMoves);

  //console.log("positionIndex", positionIndex);
  // console.log("maxMoveIndex", maxMoveIndex);

  function initLine() {
    const chess = new Chess();
    const line = lines[lineIndex];
    chess.loadPgn(line.moves);
    const moves = chess.history({ verbose: true });

    chess.reset();

    const possibleMovesArr = [];

    possibleMovesArr.push(convertMoves(chess.moves({ verbose: true })));

    moves.forEach((move, index) => {
      chess.move(move);
      let possibleMoves;
      if (playingWhite) {
        possibleMoves =
          index % 2 === 1 ? convertMoves(chess.moves({ verbose: true })) : {};
      } else {
        possibleMoves =
          index % 2 === 1 ? {} : convertMoves(chess.moves({ verbose: true }));
      }
      possibleMovesArr.push(possibleMoves);
    });

    setMoves(moves);
    setPossibleMovesArr(possibleMovesArr);
  }

  function startLesson() {
    chess.reset();

    // const possibleMoves = convertMoves(chess.moves({ verbose: true }));

    // setPossibleMoves(possibleMoves);

    setFen(chess.fen());
    setLastMove(null);
    setMoveIndex(0);
    setMaxMoveIndex(0);
    setLessonState(LessonState.IN_PROGRESS);
  }

  // function updatePositionIndex(index: number) {
  //   positionIndex.current = index;

  //   const move = moves[positionIndex.current];
  //   // move && setFen(move.before);
  //   setMoveIndex(positionIndex.current);
  // }

  // useEffect(() => {
  //   positionIndex.current = moveIndex;
  // }, [moveIndex]);

  useEffect(() => {
    initLine();
  }, [lineIndex]);

  useEffect(() => {
    const fen = moves?.[moveIndex]?.before;
    const move = moves?.[moveIndex - 1];
    setFen(fen);
    setLastMove(move);
  }, [moveIndex]);

  function moveMade(move) {
    if (!moves) {
      return;
    }
    setHighLightKey(null);

    const correctMove = moves[moveIndex];

    if (
      move.from === correctMove.from &&
      move.to === correctMove.to &&
      move.promotion === correctMove.promotion
    ) {
      if (moves.length === moveIndex + 1) {
        // setFen(move.fen);
        // setPossibleMoves({});
        setLessonState(LessonState.DONE);
        setMoveIndex(moveIndex + 1);
      } else {
        // const nextMove = moves[moveIndex + 1];
        // chess.move(move);
        const newMoveIndex = moveIndex + 1;
        setMoveIndex(newMoveIndex);
        setMaxMoveIndex(newMoveIndex);

        // chess.move(nextMove);
        // const fen = chess.fen();
        // const nextPossibleMoves = convertMoves(chess.moves({ verbose: true }));
        setTimeout(() => {
          // setFen(fen);
          // setPossibleMoves(nextPossibleMoves);
          setMoveIndex(newMoveIndex + 1);
          setMaxMoveIndex(newMoveIndex + 1);
          // setLastMove(nextMove);
        }, 300);
        // setLessonState(LessonState.CORRECT_MOVE);
      }
    } else {
      setFen(move.fen);
      // setPossibleMoves(possibleMoves);
      // setMoveIndex(moveIndex);
      // setLessonState(LessonState.INCORRECT_MOVE);

      setTimeout(() => {
        // setMoveIndex(moveIndex + 1);
        setCount((count) => count + 1);
        setFen(moves[moveIndex].before);
      }, 100);
    }
  }

  return (
    <div className="flex justify-start w-full my-8 overflow-x-visible rounded-lg bg-athens-gray-150">
      <div className="flex">
        <Board
          lastMove={lastMove}
          settings={settings}
          fen={fen}
          animate={true}
          size={boardSize}
          playingWhite={playingWhite}
          possibleMoves={possibleMoves}
          onMoveMade={(move) => moveMade(move)}
          highLightKey={highLightKey}
        />
      </div>
      <div
        className={
          "flex flex-col items-stretch justify-between min-w-[260px] rounded-r-md px-4 pb-4 bg-athens-gray-150"
        }
        style={{ height: boardSize + 44 + "px" }}
      >
        <div className="flex flex-col ">
          <div className="w-full pt-4 pb-2 text-base font-semibold text-center ">
            {title} <br />
            <span className="text-sm font-normal">
              line {lineIndex + 1}/{lines.length}
            </span>
          </div>
          {
            <div className="flex items-start w-full pb-4 mx-auto space-x-3">
              <div
                className={`relative flex-grow p-4 overflow-scroll text-gray-900 bg-white leading-normal text-[15px] rounded-lg`}
              >
                <div className="">{comment}</div>
              </div>
            </div>
          }
        </div>

        <div className="flex flex-col items-start w-full pb-4 mx-auto">
          {lessonState === LessonState.OPENING && (
            <div className="flex justify-center w-full mt-3">
              <Button
                className="font-bold "
                onClick={() => startLesson()}
                size="lg"
              >
                Start learning
              </Button>
            </div>
          )}
          {lessonState == LessonState.IN_PROGRESS && (
            <div className="flex flex-col items-center w-full">
              <div className="p-2 text-sm">
                Move {commentIndex}/{line.comments.length - 1}
              </div>
              <Progress
                className="mb-5 border border-gray-300"
                value={(moveIndex / (moves.length - 1)) * 100}
              />

              <div className="flex items-center justify-center w-full gap-1 ">
                <Button
                  variant="secondary"
                  size="sm"
                  className="mr-2 bg-athens-gray-50 hover:bg-white"
                  onClick={() => {
                    const key = moves[moveIndex].from;
                    setHighLightKey(key);
                  }}
                >
                  Hint
                </Button>
                <Button
                  variant="secondary"
                  className="bg-athens-gray-50 hover:bg-white"
                  disabled={moveIndex === 0}
                  size="sm"
                  onClick={() => {
                    if (moveIndex > 0) {
                      setMoveIndex((moveIndex) => moveIndex - 1);
                      // setTimeout(() => {
                      //   setMoveIndex((moveIndex) => moveIndex - 1);
                      // }, 300);
                    }
                  }}
                >
                  <FaStepBackward />
                </Button>
                <Button
                  variant="secondary"
                  className="bg-athens-gray-50 hover:bg-white"
                  disabled={moveIndex === maxMoveIndex}
                  size="sm"
                  onClick={() => {
                    if (moveIndex < maxMoveIndex) {
                      setMoveIndex((moveIndex) => moveIndex + 1);
                    }
                  }}
                >
                  <FaStepForward />
                </Button>
              </div>
            </div>
          )}

          {lessonState === LessonState.DONE && (
            <div className="flex flex-col items-center justify-center w-full mt-3">
              <div className="pb-2 text-base font-semibold">
                <span className="flex items-center gap-1.5">
                  <MoveIcon moveType={MoveType.GOOD} />{" "}
                  <div>Congratulations!</div>
                </span>
              </div>
              <div className="pb-6 text-sm">
                {lineIndex == maxLines - 1
                  ? t("You have completed all the lines")
                  : t("You have completed the line")}
              </div>
              {lineIndex < maxLines - 1 ? (
                <Button
                  className="font-bold "
                  onClick={() => {
                    setLineIndex(lineIndex + 1);
                    startLesson();
                  }}
                  size="lg"
                >
                  Start next line
                </Button>
              ) : (
                <Button
                  className="font-bold "
                  onClick={() => {
                    setLineIndex(0);
                    startLesson();
                  }}
                  size="lg"
                >
                  Restart
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
